import { render, staticRenderFns } from "./Autor.vue?vue&type=template&id=0792ae88&scoped=true"
import script from "./Autor.vue?vue&type=script&lang=js"
export * from "./Autor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0792ae88",
  null
  
)

export default component.exports